import { IconSparkles } from "@tabler/icons-react"
import CountUp from "react-countup"
import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"

const Section4 = () => {
  return (
    <div className="s4-partner f-width m-auto">
        <p className="s4-h-text text-center"><IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> Voosh x Olo success by the numbers.</p>
        <div className="s1-head-text text-center px-2"><p>15+ brands across 400+ locations have already recovered over $900k in delivery revenue, corrected 72k order issues and saved 5,400+ hours of manual work — proof that third-party recovery delivers real results.</p></div>
        <div className="row">
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col1">
                    <p className="p1"><CountUp delay={0.2} start={0} end={8} duration={6} />%+</p>
                    <p className="p2">Revenue lift.</p>
                </motion.div>
            </div>
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col2">
                    <p className="p1">$<CountUp delay={0.2} start={0} end={900} duration={6} />K+</p>
                    <p className="p2">Recovered.</p>
                </motion.div>
            </div>
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col3">
                    <p className="p1"><CountUp delay={0.2} start={0} end={72} duration={6} />K+</p>
                    <p className="p2">Errors resolved.</p>
                </motion.div>
            </div>
            <div className="col-sm-12 col-lg-3">
                <motion.div variants={item} whileInView="visible" initial="hidden" className="col4">
                    <p className="p1">5.4k+</p>
                    <p className="p2">Hours saved.</p>
                </motion.div>
            </div>
        </div>
    </div>
  )
}

export default Section4